var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',[_c('navbar')],1),_c('el-main',[_c('scriptdetail',{attrs:{"id":_vm.id}})],1),_c('el-footer',[_c('icp-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }